exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"AvailableServices.css","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"importLoaders":1,"sourceMap":true,"modules":true,"localIdentName":"[name]-[local]-[hash:base64:5]","minimize":false,"discardComments":{"removeAll":true}}!../~/postcss-loader?pack=default!./routes/admin/available_services/AvailableServices.css
// module id = 1420
// module chunks = 0